var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('am2-item-multiselect',{attrs:{"to":"card-sub-details","items":_vm.campaigns,"defaultValue":_vm.defaultValue,"data-test-id":_vm.dataTestId,"item-label":"campaigns"},on:{"select":_vm.handleSelect,"updateSearchText":_vm.updateSearchText}})}
var staticRenderFns = []

export { render, staticRenderFns }